const ContactBadges = () => {
    return (
        <div className="ContactBadges">
            <div className="contactBadge">
                <div className="contactBadgeImgContainer">
                    <img
                        src="/images/john-doe.jpg"
                        className="profileImg"
                        alt="logo"
                    />
                </div>
                <div className="contactBadgeDetails">
                    <div className="nameAndTitle">
                        <span>John Doe</span>
                        <b>CEO</b>
                    </div>
                    <div className="contactDetails">
                        <span>john.doe@dentons.com</span>
                    </div>
                </div>
            </div>
            <div className="contactBadge">
                <div className="contactBadgeImgContainer">
                    <img
                        src="/images/tom-harris.jpg"
                        className="profileImg"
                        alt="logo"
                    />
                </div>
                <div className="contactBadgeDetails">
                    <div className="nameAndTitle">
                        <span>Tom Harris</span>
                        <b>President</b>
                    </div>
                    <div className="contactDetails">
                        <span>tom.harris@dentons.com</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactBadges;
